import ReactECharts from 'echarts-for-react'
import moment from 'moment'
import {SystemRole} from '../../Constants'
import {useAppConfig} from '../../context/app/AppContext'
import {useUserHospital} from '../../context/hospital/UserHospitalContext'
import TranslateUtils from '../../i18n/TranslateUtils'
import {useAuth} from '../authentication/AuthProvider'
import {useListUserStatistic} from './query-keys/ChartQueryManager'

const BarChart = () => {
    //#region Context
    const {currentHospital} = useUserHospital()
    const {user} = useAuth()
    const {userRole} = useAppConfig()
    //#endregion

    //#region Translate
    const {translateCommons} = TranslateUtils()
    //#endregion

    //#region Query
    const currentYear = moment(new Date()).format('YYYY')

    const {data} = useListUserStatistic(
        user?.id,
        userRole === SystemRole.USER_WITH_ROLE ? currentHospital?.id : null,
        currentYear,
    )
    //#endregion

    //#region Generate Chart
    const generateMonths = () => {
        let months = []
        for (let i = 0; i < 12; i++) {
            months.push(
                `${currentYear + '-' + (i + 1 < 10 ? '0' + (i + 1) : i + 1)}`,
            )
        }

        return months
    }

    const option = {
        legend: {
            // data: ['New Users', 'Active Users', 'Discharged Users'],
            top: 'bottom',
        },
        title: [
            {
                left: 'center',
                text: translateCommons('User Statistics'),
                subtext:
                    translateCommons('Showing the number of users in') +
                    ' ' +
                    currentYear,
            },
        ],
        toolbox: {
            show: true,
            feature: {
                mark: {show: true},
                saveAsImage: {
                    show: true,
                    title: translateCommons('Save as image'),
                },
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
        },
        tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
        },
        xAxis: [
            {
                type: 'category',
                data: generateMonths(),
            },
        ],
        yAxis: [
            {
                type: 'value',
                allowDecimals: false,
            },
        ],
        // grid: [{}],
        series: [
            // These series are in the first grid.
            {
                name: translateCommons('New Users'),
                type: 'bar',
                seriesLayoutBy: 'row',
                emphasis: {
                    focus: 'series',
                },
                data: data?.newUsers ? data.newUsers : [],
            },
            {
                name: translateCommons('Active Users'),
                type: 'bar',
                seriesLayoutBy: 'row',
                emphasis: {
                    focus: 'series',
                },
                data: data?.activeUsers ? data.activeUsers : [],
            },
            {
                name: translateCommons('Discharged Users'),
                type: 'bar',
                seriesLayoutBy: 'row',
                emphasis: {
                    focus: 'series',
                },
                data: data?.dischargedUsers ? data.dischargedUsers : [],
                color: '#C24641',
            },
        ],
    }
    //#endregion

    return (
        <div className="h-full w-full p-3 border-1 border-gray-100 border-round-lg">
            <ReactECharts
                style={{
                    height: '100%',
                    width: '100%',
                    zIndex: '0',
                    position: 'relative',
                }}
                lazyUpdate
                option={option}
            />
        </div>
    )
}

export default BarChart
